import React from "react";
import { getUrlForInstrument } from "app/main/urlFormatter";
import { AssetClass } from "interfaces/enums";

import "./style.scss";
import { PerformanceLabel } from "app/performance/PerformanceLabel/PerformanceLabel";
import { DynamicLink } from "app/links/DynamicLink/DynamicLink";

export interface StreamListItemProps {
    name: string;
    isin: string;
    performance: number | null;
    assetClass: AssetClass;
}

export const StreamListItem = ({ name, isin, performance, assetClass }: StreamListItemProps): JSX.Element => {
    return (
        <DynamicLink className="streamItem" href={getUrlForInstrument(assetClass, isin, name)}>
            <span>{name}</span>
            <PerformanceLabel value={performance} noBackground />
        </DynamicLink>
    );
};
